import Vue from 'vue';
import Vuex from 'vuex';
import partners from '@/store/modules/partners';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		user: null,
		loadingCount: 0,
		sideIndex: 0,
		selectedMenu: '',
		subTitle: '',
		showModal: false,
		report: { state_scope_context: null },
		//menus: [],
	},
	getters: {
		// isLoggedIn() {
		// 	//return !!state.token;
		// 	var temp = this.$session.exists();
		// 	console.log('session', temp);
		// 	return this.$session.exists();
		// },
		// userToken(state) {
		// 	return state.token;
		// },
		isLoading(state) {
			return state.loadingCount > 0;
		},
		getSubTitle(state) {
			return state.subTitle;
		},
		getSelectedMenu(state) {
			return state.selectedMenu;
		},
		getSideIndex(state) {
			return state.sideIndex;
		},
		getShowModal(state) {
			return state.showModal;
		},
		getReport(state) {
			return state.report;
		},
		getDefaultPageSize() {
			const user = Vue.prototype.$session.get('user');

			if (!user) return 0;

			return 25;
		},
		// getMenus(state) {
		// 	return state.menus;
		// },
		// access(state) {
		// 	return { view_yn: 'Y', modify_yn: 'Y' };
		// },
	},
	mutations: {
		// getToken(state) {
		// 	state.token = localStorage.getItem('token');
		// },
		// delToken(state) {
		// 	localStorage.removeItem('token');
		// 	state.token = null;
		// },
		setLoading(state, isLoading) {
			//console.log('loading count:' + state.loadingCount);
			if (isLoading) {
				state.loadingCount++;
			} else if (state.loadingCount > 0) {
				state.loadingCount--;
			}
		},
		setSubTitle(state, subTitle) {
			state.subTitle = subTitle;
		},
		setSelectedMenu(state, selectedMenu) {
			state.selectedMenu = selectedMenu;
		},
		setSideIndex(state, sideIndex) {
			state.sideIndex = sideIndex;
		},
		setReport(state, report) {
			if (report.state_scope_context && !report.state_scope_context.valid) return;
			state.report.state_scope_context = report.state_scope_context || null;
			state.report.data = report.data;
			state.report.fileName = report.fileName;
			state.report.reportTemplate = report.reportTemplate;
			state.report.type = report.type;
			state.report.base64 = report.base64;
			state.report.mailModalOpen = report.mailModalOpen;
			state.report.toList = report.toList;
			state.report.modalWidth = report.modalWidth;
			state.showModal = true;
		},
		setShowModal(state, value) {
			state.showModal = value;
		},
		// setMenus(state, menus) {
		// 	state.menus = menus;
		// },
	},
	actions: {},
	modules: { partners },
});
